interface WelcomeFlashProps {
  show: boolean;
}

// One-time reveal shown the moment the first stamp confirms, then the full
// dashboard mounts underneath. Reuses the .level-up-flash overlay styling.
export default function WelcomeFlash({ show }: WelcomeFlashProps) {
  if (!show) return null;

  return (
    <div className="level-up-flash">
      <div
        className="rounded-[16px] p-8 text-center"
        style={{ background: 'linear-gradient(180deg,#f96a55,#ffcc00 45%,#36d9d3)' }}
      >
        <p className="font-heading text-lg text-white">YOU'RE IN</p>
        <p className="font-grotesk font-bold text-2xl text-white mt-2">WELCOME TO THE GAME</p>
      </div>
    </div>
  );
}
